export default "__VITE_ASSET__B6z7DDHB__"